import { render, staticRenderFns } from "./ClientNotification.vue?vue&type=template&id=41c8bd2d&"
import script from "./ClientNotification.vue?vue&type=script&lang=js&"
export * from "./ClientNotification.vue?vue&type=script&lang=js&"
import style0 from "./ClientNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports